export default "/images/168161ddb96545e327d78dcf395c6a07.avif";